import { jsxs as u, jsx as s } from "react/jsx-runtime";
import { forwardRef as f, useCallback as g, useMemo as v } from "react";
import t from "./styles.module.less.js";
import I from "./calendar.svg.js";
const h = f((r, c) => {
  var l;
  const { value: e, disabled: a, onChange: i, error: d } = r, m = g((n) => {
    a || i(n.target.value);
  }, [a, i]), p = v(() => {
    if (e && !isNaN(e))
      return new Date(e).toISOString().split("T")[0];
    if (e)
      try {
        return new Date(e).toISOString().split("T")[0];
      } catch {
        try {
          const o = e.split("-").reverse().join("-");
          return new Date(o).toISOString().split("T")[0];
        } catch (o) {
          console.error(o);
        }
      }
    return "";
  }, [e]);
  return /* @__PURE__ */ u("div", { className: `${t.dateTimeInputWrapper} ${d ? t.error : ""}`, children: [
    /* @__PURE__ */ s(
      "input",
      {
        ref: c,
        ...r.props,
        className: `${t.dateTimeInput} ${(l = r.props) == null ? void 0 : l.className}`,
        type: "datetime-local",
        value: p,
        onChange: m,
        disabled: a
      }
    ),
    /* @__PURE__ */ s("div", { className: t.calendarIcon, children: /* @__PURE__ */ s(I, {}) })
  ] });
});
h.displayName = "DateTimeInput";
export {
  h as DateTimeInput
};
